/*匹配SEO所需要请求的路由*/
export function matchExpr(){
    let matchExpr;
    matchExpr = [
        { "index": "Index", "regex": /^\/$/ },

        // { "index": "brandall", "regex": /^\/brandAll/ },  
        //{ "index": "category", "regex": /^\/category\/(\d+(-))+(\/)?/ }
        { "index": "brandall", "regex": /^\/brand\/$/ },  
        { "index": "brand", "regex": /^\/brand\/((?!story).)/ },             
        { "index": "brand", "regex": /^\/brands\/((?!story).)/ },             
        { "index": "search", "regex": /^\/search\/(?!v2)/ },
        { "index": "searchv2", "regex": /^\/search\/v2/ },
        { "index": "hot", "regex": /^\/hot/ },
        { "index": "gift_set", "regex": /^\/gift_set/ },
        { "index": "exclusive_product", "regex": /^\/exclusive_product/ },
        { "index": "categoryonelevel", "regex": /^\/category/ },
        { "index": "category", "regex": /^\/category\/(.+(-))+(\/)?/ },
        { "index": "category", "regex": /^\/categories\/(.+(-))+(\/)?/ },
        { "index": "fun", "regex": /^\/function/ },

        { "index": "product", "regex": /^\/product(\/)?/ },
        { "index": "campaign", "regex": /^\/campaign/ },
        { "index": "weeklyspecials", "regex": /^\/weeklyspecials/ },
        { "index": "contentPage", "regex": /^\/content/ },
        { "index": "rank", "regex": /^\/rank(\-\d*)?(\-\d*)?\/$/ },
        { 
          "index": "navigationBrandGroup",
          "regex": /^\/(reservation|filterLipStick|confirmProduct|myAccount|my-account|myOrderList|integralFlow|order)/
        },
        { "index": "SpecialOfferList", "regex": /^\/v2\/html\/SpecialOfferList/ },

    ];
    return  matchExpr;
}

export function getEnv( title, values, protocol ){
    switch( title ){
        case "node":
            if( protocol === 'https' ){
                return JSON.parse( process.env.GlobalEnv )[values].replace('http','https');
            }else{
                return JSON.parse( process.env.GlobalEnv )[values];
            }
        case "browser":
            if( protocol === 'https' ){
                return window.__INITIAL_ENV__[values].replace('http','https');
            }else{
                return window.__INITIAL_ENV__[values];
            }
    }
}

export function GetSingleCookie( cookies, value ){
    var arr = cookies.match(new RegExp("(^| )"+value+"=([^;]*)(;|$)"));
    if(arr != null)
        return unescape(arr[2]);
    return null;
}

export function getCookie(params, callback){

    // prototype
    let relCookieID = null;
    let relCookieToken = null;

    if( !params.Cookie ){
        // NO Cookie Callback Ghost
        return callback( relCookieID , relCookieToken );
    }

    if( GetSingleCookie( params.Cookie , 'Token' ) ){
        relCookieToken = GetSingleCookie( params.Cookie , 'Token' );
    }

    // NO match Callback Ghost
    return callback( relCookieID , relCookieToken );
}


// WEBPACK FOOTER //
// ./configuration/ConfigExpr.js